var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-form"},[_c('RequestFormNav'),_c('iframe',{attrs:{"title":"form","src":_vm.source,"width":"100%","height":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }